import { ConfigProvider, theme } from "antd";
import antdThemeConfig from "global/styles/antd/config.json";

const WithAntdTheme = ({ children }) => {
  return (
    <ConfigProvider
      theme={{ ...antdThemeConfig, algorithm: theme.darkAlgorithm }}
    >
      {children}
    </ConfigProvider>
  );
};

export default WithAntdTheme;
